
import { AuthService } from "@/services/auth-service";
import { PaymentService } from "@/services/payment-service";
import { printLocalDate, printHumanFloat } from "@/utils/pretty-print";
import VueI18n from "vue-i18n/types";
import Vue from "vue";

export default Vue.extend({
	filters: {
		printHumanFloat
	},
	data() {
		return {
			canBuy: false,
			price: 0,
			vat: 0,
			priceExcVat: 0,
			ready: false,
		};
	},
	props: {
		disabled: Boolean
	},
	computed: {
		validUntilText(): VueI18n.TranslateResult {
			if (AuthService.wfCompany.ServicePackExpirationDate == null) {
				return this.$ct("service-pack-permanently-valid");
			}
			if (AuthService.wfCompany.ServicePackExpirationDate < new Date()) {
				return this.$ct("service-pack-is-expired");
			}
			return this.$ct("service-pack-valid-until", {date: printLocalDate(AuthService.wfCompany.ServicePackExpirationDate)});
		},
	},
	methods: {
		async buy() {
			await PaymentService.buyServicePack();
		}
	},
	async created() {
		let result = await PaymentService.getServicePackPrice();
		this.canBuy = result.canBuy;
		this.price = result.price;
		this.vat = result.vat;
		this.priceExcVat = result.priceExcVat;
		this.ready = true;
	},
	i18nEx: {
		componentPrefix: "components.account"
	},
});
